<!--
  下拉选择组件
-->
<template>
  <el-select
    size="small"
    clearable
    placeholder="请选择"
    :value="curValue"
    @change="handleInput"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :style="item.style || ''"
    >
    </el-option>
  </el-select>
</template>

<script>
import Vue from 'vue';
export default {
  name: 'BaseElSelect',
  props: ['value', 'options'],
  data: () => {
    return {
      curValue: [],
    }
  },
  watch: {
    value(n) {
      this.curValue = n;
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    }
  }
}
</script>
